import { render, staticRenderFns } from "./radioTableCont.vue?vue&type=template&id=06f77251"
import script from "./radioTableCont.vue?vue&type=script&lang=js"
export * from "./radioTableCont.vue?vue&type=script&lang=js"
import style0 from "./radioTableCont.vue?vue&type=style&index=0&id=06f77251&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports